/**
 * 2020/4/2 - 15:17
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 *
 */
import moment from 'moment'
import { isArray, isEmpty } from 'lodash'
// import { message } from 'ant-design-vue'
import store from '@/store'

export const BASE_TYPES = ['number', 'string', 'symbol', 'boolean', 'undefined', 'null']
/**
 * 表格中翻译状态码
 * @param recordCode table->row中的某个状态码
 * @param key 系统状态包(语言包)中的key
 * @param map 系统状态包(语言包)
 * @returns {string|*}
 */
export const translateStatusCode = (recordCode, key, data) => {
  const map = data || store.getters['app/dataMap']
  recordCode += ''
  if (!recordCode) {
    return '-'
  }
  return map[key][recordCode]
}

export const changeStatus = (text, record, index) => {
  const status = text === 1 ? '发送中' : (text === 2 ? '发送成功' : '发送失败')
  return status
}

/**
 * 时间转化
 * @param seconds 秒数
 * @param pattern 正则
 * @returns {string}
 */
// export const formatDateBySecs = (seconds, pattern = 'YYYY-MM-DD HH:mm:ss') => {
//   seconds = seconds * 1000
//   return formatDateByMilliSeconds(seconds, pattern)
// }

/**
 * 时间转化
 * @param milliseconds 毫秒数
 * @param pattern 正则
 * @returns {string}
 */
export const formatDateByMilliSeconds = (milliseconds, pattern = 'YYYY-MM-DD HH:mm:ss') => {
  return moment(milliseconds).format(pattern)
}

export const getSelectOptionsByDataMap = (msgStatus, dataMap) => {
  if (!dataMap) {
    dataMap = store.getters['app/dataMap']
  }
  msgStatus += ''
  if (!msgStatus || !dataMap) {
    return []
  }
  const statusMap = dataMap[msgStatus]
  if (!statusMap) {
    // message.error('系统找不到对应的状态码, 请联系管理员后重试!')
    return []
  }
  return Object.keys(statusMap).map(it => {
    return {
      key: it + '',
      value: statusMap[it]
    }
  })
}

export const getMomentObject = (dateTime, pattern = 'YYYY-MM-DD HH:mm:ss') => {
  return dateTime ? moment(dateTime, pattern) : null
}

// 生成树结构，带parentCode及唯一key
export const getTreeData = (data, index = null) => {
  if (isArray(data)) {
    return data.map((it, id) => {
      const { children, code, name } = it
      const key = index ? `${index}-${code}` : code
      const object = {}
      if (children && children.length > 0) {
        object.children = getTreeData(children, key)
      }
      return {
        ...object,
        key,
        parentKey: index,
        code: code,
        title: name
      }
    })
  }
}

// 扁平化tree
export const flatten = data => {
  return data.reduce((arr, { key, code, title, parentKey, children = [] }) =>
    arr.concat([{
      key,
      code,
      title,
      parentKey
    }], flatten(children)), [])
}

export const getCheckedKeys = (total, child) => {
  const childData = getTreeData(child)
  const flattenData = flatten(childData)
  const keys = flattenData.map(it => it.key)
  return keys
}

export const getArrayByObjectAttrs = object => {
  if (isEmpty(object)) {
    return []
  }
  return Object.keys(object).reduce((arr, key) => {
    return [
      ...arr,
      {
        key,
        value: object[key]
      }
    ]
  }, [])
}

export const getCheckedCodeTree = (keys, tree) => {
  if (!keys) {
    return []
  }
  const treeArray = flatten(tree) // 扁平化
  const resArray = treeArray.filter(it => keys.includes(it.key)) // match
  // 如果只是只选中一个直接返回就行，如果是多个则可能是扁平化之后的tree 需要重新生成tree
  const resTree = resArray.length === 1 ? resArray : buildTree(resArray)
  return resTree
}

/**
 * flat array to tree
 * @param list
 * @param options
 * @returns {[]}
 */
export const buildTree = (list, options = {}) => {
  const {
    keyField = 'key',
    childField = 'children',
    parentField = 'parentKey'
  } = options

  const tree = []
  const record = {}
  for (let i = 0, len = list.length; i < len; i++) {
    const item = list[i]
    const id = item[keyField]

    if (!id) {
      continue
    }

    if (record[id]) {
      item[childField] = record[id]
    } else {
      item[childField] = record[id] = []
    }

    if (item[parentField]) {
      const parentId = item[parentField]
      if (!record[parentId]) {
        record[parentId] = []
      }
      record[parentId].push(item)
    } else {
      tree.push(item)
    }
  }
  return tree
}

export const getTreeLastChildren = tree => {
  const result = []
  getLast(tree)
  function getLast (tree) {
    for (let i = 0; i < tree.length; i++) {
      const item = tree[i]
      if (item.children && item.children.length > 0) {
        getLast(item.children)
      } else {
        result.push(item)
      }
    }
  }
  return result
}
